module.exports = __webpack_public_path__ + "media/bootstrap-icons/badge-vo-fill-a52ead09.svg";